// ---------------------------------------------------------------------------
// MARQUEE — two rows of rubros the system serves. CSS-only animation
// (no JS / no framer-motion) for performance.
// ---------------------------------------------------------------------------

const row1 = [
  "ABERTURAS",
  "PILETAS",
  "CLIMATIZACIÓN",
  "REFORMAS",
  "PLOMERÍA",
  "ELECTRICIDAD",
  "PAISAJISMO",
  "CERRAMIENTOS",
  "TALLERES MECÁNICOS",
];

const row2 = [
  "DISTRIBUIDORAS",
  "IMPORTADORAS",
  "MAYORISTAS",
  "CORRALONES",
  "FÁBRICAS",
  "REPUESTOS",
  "ALIMENTOS",
  "BAZAR Y BLANQUERÍA",
  "INMOBILIARIAS",
];

function Row({
  items,
  reverse,
  cls,
}: {
  items: string[];
  reverse?: boolean;
  cls: string;
}) {
  return (
    <div
      className="flex w-max"
      style={{
        animation: `${reverse ? "marquee-reverse" : "marquee"} ${
          reverse ? 45 : 60
        }s linear infinite`,
      }}
    >
      {[0, 1].map((dup) => (
        <div
          key={dup}
          className={`flex gap-7 pr-7 font-mono whitespace-nowrap ${cls}`}
          style={{ fontSize: 14, letterSpacing: "0.06em" }}
        >
          {items.map((item) => (
            <span key={item}>{item} ·</span>
          ))}
        </div>
      ))}
    </div>
  );
}

export function HomeMarquee() {
  return (
    <section className="py-7 border-b border-[#221F2A] overflow-hidden flex flex-col gap-3.5">
      <Row items={row1} cls="text-[#6E6A7A]" />
      <Row items={row2} reverse cls="text-[#9C98A6]" />
    </section>
  );
}
